function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(74,50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 1
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.9333333333333333s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.9333333333333333s"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(71.92509098342242,59.761679433819204)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(24)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 0.9333333333333333
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.8666666666666667s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.8666666666666667s"
}))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(66.05913455261259,67.83547581145746)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(48)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 0.8666666666666667
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.8s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.8s"
}))));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(57.41640786499874,72.82535639108369)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(72)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 0.8
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.7333333333333333s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.7333333333333333s"
}))));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(47.49131688157632,73.86852548883856)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(96)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 0.7333333333333333
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.6666666666666666s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.6666666666666666s"
}))));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(38.00000000000001,70.78460969082653)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(119.99999999999999)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 0.6666666666666666
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.6s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.6s"
}))));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(30.583592135001265,64.10684605501936)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(144)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 0.6
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.5333333333333333s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.5333333333333333s"
}))));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(26.524457582388663,54.989880579626224)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(168)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 0.5333333333333333
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.4666666666666667s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.4666666666666667s"
}))));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(26.524457582388663,45.01011942037378)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(192)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 0.4666666666666667
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.4s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.4s"
}))));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(30.58359213500126,35.89315394498065)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(216)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 0.4
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.3333333333333333s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.3333333333333333s"
}))));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.999999999999986,29.215390309173475)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(239.99999999999997)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 0.3333333333333333
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.26666666666666666s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.26666666666666666s"
}))));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(47.491316881576296,26.131474511161443)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(264)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 0.26666666666666666
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.2s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.2s"
}))));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(57.41640786499873,27.174643608916313)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(288)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 0.2
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.13333333333333333s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.13333333333333333s"
}))));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(66.0591345526126,32.16452418854254)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(312)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 0.13333333333333333
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.06666666666666667s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.06666666666666667s"
}))));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(71.92509098342242,40.238320566180796)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(336)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "#ffaf38",
  fillOpacity: 0.06666666666666667
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "0s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "0s"
}))));

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "250px",
    height: "250px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.699d5e5c.svg";
export { ForwardRef as ReactComponent };